var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Interfaces = OCS.Viewer.Interfaces || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Functions.define_data_store_interface = function () {
    return {
        time_to_retr_removal: 3000,
        last_retrieved: {},
        last_retr_timeout: null,
        minified_keys: ['timestamp_epoch', 'dataset', 'grid', 'false', 'data_gate',
            'payload', 'entry', 'metadata', 'datatype', 'source_type', 'req_cat_type',
            'data_var', 'data_unit', 'grid-properties', 'variables',
            'edu.ou.mesonet.standard', 'edu.ou.ocs.nids', 'edu.ou.ocs.advisories', 'edu.ou.ocs.lightning', "org.mesonet.okfirst.shapes",
            'significance', 'action', 'phenom', 'beginning_time', 'ending_time',
            'draw_type', 'issued_time', 'coordinates', 'Feature', 'features', 'properties', 'type', 'geometry',
            'Polygon', 'data', 'format', 'geojson', 'json', 'info', 'data_gate', 'cntr_lmbd',
            'cntr_phi', 'tilt_angle', 'num_of_rng_bins', 'scale_fctr', 'num_of_rdls',
            'rdl_ang_strt', 'req_cat_type', 'layer_name', 'rdl_ang_dlt', 'bin_word', 'degrees_north', 'degrees_east', 'timestamp', 'success',
            'DataMngrDataRequest', 'units', 'src_id', 'prod_code', 'op_mode', 'scl_fctr_clc', 'km_per_bin',
            'null,null,null,null,null,null,null', "0,0,0,0,0,0,0,0,0,0,0,0,0", "0,0,0,0,0,0,0,0,0", '0.6313728569089486', '-1.6679064463758608', '0.9999619230641713',
            '1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1',
            "000000000000"
        ],

        /*
         * Event Fires
         */
        new_data_stored: function (data) {
            setTimeout(function () {
                this.fireEvent('new_data_stored', data);
            }.bind(this), 0);
        },
        new_data_not_stored: function (data) {
            this.fireEvent('new_data_not_stored', data);
        },
        clear_storage: function () {
            var sm = OCS.Viewer.Functions.get_storage_manager();
            sm.fireEvent('clear_storage');
        },
        /*
         * Event Listeners
         */

        /*
         * on_data_expiration
         * @param {Object} exp_event
         * @param {Integer} exp_event.data_time
         * @param {Integer} exp_event.current_time
         * @param {Object|Integer|String} exp_event.data
         * @param {String} exp_event.key
         * @param {storage_manager} exp_event.storage_manager
         * @returns {undefined}
         */
        on_data_expiration: function (exp_event) {
            var data = OCS.Functions.define_data_obj(this.unminify(exp_event.data));
            var info = data.get_info();
            if (info && !info.url) {
                if(!exp_event.storage_manager.storage_store(exp_event.key, exp_event.storage_manager.prepare_json_value(exp_event.data, exp_event.storage_manager.options.js_storage_type_string, {timestamp_epoch: exp_event.data_time}), exp_event.storage_manager.options.js_storage_type_string, {timestamp_epoch: exp_event.data_time})) {
                    this.cache_data(exp_event.key, data);
                }
            }
        },

        /*
         * Actions
         */
        store_new_data: function (data, overwrite) {
            if (data) {
                var sm = OCS.Viewer.Functions.get_storage_manager();
                var j, variable, existing_data, vars, vars_with_units;
                var timestamp_epoch = data.get_timestamp_epoch();
                var dataset = data.get_dataset();
                var info = data.get_info();
                vars_with_units = vars = data.get_variables();
                if (vars && vars.length) {
                    vars_with_units = data.get_variables_with_units();
                }
                var data_key = this.get_storage_key(dataset, data.is_gridded(), timestamp_epoch, vars_with_units);

                // Make sure we haven't seen this data go by already, if not store it
                if (!overwrite) {
                    existing_data = this.get_stored_data(data_key);
                    if (existing_data) {
                        for (j = 0; j < vars.length; j++) {
                            variable = vars[j];
                            if (!existing_data.contains_data_variable(variable)) {
                                existing_data.add_data_variable(data.get_data_variable(variable), variable);
                            }
                        }
                        data = existing_data;
                    }
                }
                var type = sm.options.default_storage_type;
                var options = null;

                if (dataset === "edu.ou.ocs.nids" || dataset === "edu.ou.ocs.lightning") {
                    type = sm.options.js_storage_type_string;
                }
                if (dataset === "org.mesonet.okfirst.shapes") {
                    type = sm.options.session_storage_type_string;
                }

                if (!this.options.store_locally) {
                    type = sm.options.js_storage_type_string;
                }

                if (!timestamp_epoch) {
                    type = sm.options.js_storage_type_string;
                } else {
                    var dateObj = OCS.Functions.get_OCSDateTime();
                    if (sm.is_time_expired(timestamp_epoch, type, dateObj.get_server_epoch_time())) {
                        type = sm.options.js_storage_type_string;
                    }
                    options = {"timestamp_epoch": timestamp_epoch};
                }

                if(type === sm.options.js_storage_type_string && info.url) {
                    return false;
                }


                if (sm.store(data_key, this.minify(data.stringify()), type, options)) {
                    this.new_data_stored(data);
                    return data_key;
                } else {
                    this.new_data_not_stored(data);
                }
            }
            return false;
        },
        cache_data: function (data_key, data) {
            this.set_last_retr_timeout();
            this.last_retrieved[data_key] = data;
            this.set_last_retr_timeout();
        },
        get_cached_data: function (data_key) {
            if (this.last_retrieved[data_key]) {
                this.set_last_retr_timeout();
                return this.last_retrieved[data_key];
            } else {
                return false;
            }
        },

        get_accumulated_data: function (request) {
            var i, timestamp_epoch, storage_key, data;
            var timestamp_array = request.get_initial_req_timestamp_array();
            var dataset = request.get_dataset();
            var gridded = request.is_gridded();
            var vars = request.get_variables();
            if (timestamp_array && timestamp_array.length) {
                for (i = 0; i < timestamp_array.length; i++) {
                    timestamp_epoch = timestamp_array[i];
                    storage_key = this.get_storage_key(dataset, gridded, timestamp_epoch, vars);
                    data = this.get_stored_data(storage_key);
                    if (data && data.contains_all_data_variables(vars)) {
                        request.fireEvent('new_data_arrival', data);
                    }
                }
            } else {
                storage_key = this.get_storage_key(dataset, gridded, timestamp_epoch, vars);
                data = this.get_stored_data(storage_key);
                if (data && data.contains_all_data_variables(vars)) {
                    request.fireEvent('new_data_arrival', data);
                }
            }
        },
        get_stored_data: function (storage_key) {
            var data = this.get_cached_data(storage_key);
            if (data) {
                return data;
            }
            var sm = OCS.Viewer.Functions.get_storage_manager();
            if (sm.data_key_exist(storage_key)) {
                this.cache_data(storage_key, OCS.Functions.define_data_obj(this.unminify(sm.retrieve(storage_key))));
                return this.get_cached_data(storage_key);
            }

            // The data is not cached nor in storage, return false
            return false;

        },
        minify: function (str) {
            //var pre_string_length = str.length;

            var key, i;
            for (i = 0; i < this.minified_keys.length; i++) {
                key = "%" + i + "%";
                str = String(str).replace(new RegExp(this.minified_keys[i], 'g'), key);
            }
            //var post_string_length = str.length;
            //console.log(this.class_name+': Minification completed: String reduced from '+pre_string_length+' to '+post_string_length+".")

            return str;
        },
        unminify: function (str) {
            var key, i;
            for (i = 0; i < this.minified_keys.length; i++) {
                key = "%" + i + "%";
                str = String(str).replace(new RegExp(key, 'g'), this.minified_keys[i]);
            }
            return str;
        },
        /*
         * Booleans
         */
        is_data_accumulated: function (request) {
            var all_data_accumulated = {result: false};
            if (!request) {
                return all_data_accumulated;
            }
            var i, timestamp_epoch, data, req_metadata, storage_key, timestamp_array, found;
            var sm = OCS.Viewer.Functions.get_storage_manager();
            var found_times = [];
            var not_found_times = [];
            req_metadata = request.get_metadata();
            var dataset = request.get_dataset();
            var gridded = request.is_gridded();
            var vars = request.get_variables();

            timestamp_array = request.get_initial_req_timestamp_array();
            if (timestamp_array && timestamp_array.length) {
                for (i = 0; i < timestamp_array.length; i++) {
                    found = false;
                    timestamp_epoch = timestamp_array[i];
                    storage_key = this.get_storage_key(dataset, gridded, timestamp_epoch, vars);
                    if (sm.data_key_exist(storage_key)) {
                        data = OCS.Functions.define_data_obj(this.unminify(sm.retrieve(storage_key)));
                        if (data && data.contains_all_data_variables(vars)) {
                            found_times.push(timestamp_epoch);
                            found = true;
                        }
                    }
                    if (!found) {
                        not_found_times.push(timestamp_epoch);
                    }
                }
                if (found_times.length === timestamp_array.length) {
                    all_data_accumulated = {result: true, found_times: found_times};
                } else {
                    all_data_accumulated = {result: false, found_times: found_times, not_found_times: not_found_times};
                }
            } else {
                storage_key = this.get_storage_key(dataset, gridded, null, vars);
                if (sm.data_key_exist(storage_key)) {
                    all_data_accumulated = {result: true};
                }
            }

            return all_data_accumulated;
        },

        /*
         * Get / Set methods
         */

        /**
         * 
         * @param {Object} metadata with dataset, timestamp_epoch and gridded
         * @returns {String}
         */
        get_storage_key: function (dataset, gridded, timestamp, vars) {
            var storage_key = dataset;
            if (gridded === true) {
                storage_key += "|" + gridded;
            }
            if (timestamp) {
                storage_key += "|" + Math.floor(timestamp / 10000);
            }
            if ((dataset === "edu.ou.ocs.nids") && vars) {
                storage_key += "|" + vars[0].parm + "|" + vars[0].units;
            }
            return this.minify(storage_key);
        },
        set_last_retr_timeout: function () {
            if (this.last_retr_timeout) {
                clearTimeout(this.last_retr_timeout);
            }
            this.last_retr_timeout = setTimeout(function () {
                this.last_retrieved = {};
            }.bind(this), this.time_to_retr_removal);
        },
        data_store_destroy: function () {
            if (this.last_retr_timeout) {
                clearTimeout(this.last_retr_timeout);
            }
            this.last_retrieved = {};
        }

    };
};
OCS.Viewer.Interfaces.DataStore = OCS.Viewer.Functions.define_data_store_interface();
/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


